/**
 * useProspectPanelState Hook - MA-ARCH-161
 * 
 * Extracted from ScriptPlay.jsx to isolate prospect panel collapse state.
 * Persists collapse state to localStorage.
 * 
 * Usage:
 * const { collapsed, setCollapsed, toggle } = useProspectPanelState();
 */

import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = "missionassist_prospect_panel_collapsed";

export function useProspectPanelState(defaultCollapsed = true) {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw === null ? defaultCollapsed : raw === "true";
    } catch {
      return defaultCollapsed;
    }
  });

  // Persist to localStorage
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, String(collapsed));
    } catch {
      // ignore
    }
  }, [collapsed]);

  // Toggle helper
  const toggle = useCallback(() => {
    setCollapsed((v) => !v);
  }, []);

  return {
    collapsed,
    setCollapsed,
    toggle,
  };
}

export default useProspectPanelState;
